import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mountain',
  templateUrl: './mountain.component.html',
  styleUrls: ['./mountain.component.css']
})
export class MountainComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
